import {
    BUBBLE_CHART_I18N_KEYS
} from '../../../../../features/shared-components/chart/constants/i18n/BubbleCharti18nConstants'

export const BUBBLE_CHART_I18N_EN = {
    [BUBBLE_CHART_I18N_KEYS.sub_topic]:             "Sub-Topic",
    [BUBBLE_CHART_I18N_KEYS.sub_topic_description]: "Description",
    [BUBBLE_CHART_I18N_KEYS.comments_percentage]:   "Comments (%)",
    [BUBBLE_CHART_I18N_KEYS.emotions_percentage]:   "Emotions (%)",
    [BUBBLE_CHART_I18N_KEYS.top_5_keywords]:        "Top 5 Keywords",
    [BUBBLE_CHART_I18N_KEYS.anger]:                 "Anger",
    [BUBBLE_CHART_I18N_KEYS.fear]:                  "Fear",
    [BUBBLE_CHART_I18N_KEYS.joy]:                   "Joy",
    [BUBBLE_CHART_I18N_KEYS.sadness]:               "Sadness",
    [BUBBLE_CHART_I18N_KEYS.no_specific_emotion]:   "No specific emotion",
    [BUBBLE_CHART_I18N_KEYS.csv]:                   "CSV"
}


// WEBPACK FOOTER //
// ./src/locales/en/features/shared_components/chart/bubble_chart.i18n.en.js